import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface LanguageState {
  fr: string[];
  en: string[];
}

interface BusinessModelIDs {
  [key: string]: string;
}
interface CustomerTypeIDs {
  [key: string]: string;
}

export interface InitialRegistrationState {
  pos: LanguageState;
  posOther: LanguageState;
  businessModel: LanguageState;
  businessModelIDs: BusinessModelIDs;
  customerTypes: LanguageState;
  customerTypeIDs: CustomerTypeIDs;
  apiSchemas: string[];
  isSubmitting: boolean;
  submitError: string | boolean;
  submitSuccess: boolean;
}

const initialState: InitialRegistrationState = {
  pos: {
    fr: [],
    en: []
  },
  posOther: {
    fr: [],
    en: []
  },
  businessModel: {
    fr: [],
    en: []
  },
  businessModelIDs: {},
  customerTypes: {
    fr: [],
    en: []
  },
  customerTypeIDs: {},
  apiSchemas: [],
  isSubmitting: false,
  submitError: false,
  submitSuccess: false
};

const sellerRegistrationSlice = createSlice({
  name: 'sellerRegistration',
  initialState,
  reducers: {
    getAllRegistrationData: (state) => {},
    setAllRegistrationData: (state, action: any) => {
      state.pos = { fr: [], en: [] };
      state.posOther = { fr: [], en: [] };
      state.businessModel = { fr: [], en: [] };
      state.businessModelIDs = {};
      state.customerTypes = { fr: [], en: [] };
      state.customerTypeIDs = {};
      state.apiSchemas = [];

      action?.payload?.data?.posType.forEach(
        ({ support, pays, country, pos_code }) => {
          const posString = `${country} ${pos_code}`;
          const posStringFR = `${pays} ${pos_code}`;

          if (support === 'supported') {
            state.pos.en.push(posString);
            state.pos.fr.push(posStringFR);
          } else {
            state.posOther.en.push(posString);
            state.posOther.fr.push(posStringFR);
          }
        }
      );

      action?.payload?.data?.businessModel.forEach((bm) => {
        const businessModelString = bm.business_model_type;
        const businessModelStringFR = bm.business_model_type_fr;

        state.businessModel.en.push(businessModelString);
        state.businessModel.fr.push(businessModelStringFR);

        state.businessModelIDs[businessModelString] = bm.business_model_id;
        state.businessModelIDs[businessModelStringFR] = bm.business_model_id;
      });

      action?.payload?.data?.customerTypes.forEach((ct) => {
        const customerTypeString = ct.customer_type;
        const customerTypeStringFR = ct.customer_type_fr;

        state.customerTypes.en.push(customerTypeString);
        state.customerTypes.fr.push(customerTypeStringFR);

        state.customerTypeIDs[customerTypeString] = ct.customer_type_id;
        state.customerTypeIDs[customerTypeStringFR] = ct.customer_type_id;
      });

      action?.payload?.data?.apiSchema.forEach((schema) => {
        state.apiSchemas.push(schema.api_schema_version);
      });

      state.submitError = false;
    },
    submitRequest: (state) => {
      state.isSubmitting = true;
      state.submitError = false;
    },
    submitSuccess: (state) => {
      state.isSubmitting = false;
      state.submitSuccess = true;
      state.submitError = false;
    },
    submitFailure: (state, action: PayloadAction<string>) => {
      state.isSubmitting = false;
      state.submitError = action.payload;
    },
    resetSuccess: (state) => {
      state.submitSuccess = false;
    }
  }
});

export const {
  getAllRegistrationData,
  setAllRegistrationData,
  submitRequest,
  submitSuccess,
  submitFailure,
  resetSuccess
} = sellerRegistrationSlice.actions;
export default sellerRegistrationSlice.reducer;
